import React, { useCallback, useState } from 'react'
import Assessments from './Assessments'
import { useLocation } from 'react-router-dom';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryClient as qc } from 'keys';
import { initialPage } from 'keys/pagination';
import { getAssessmentReportFetch } from 'store/middlewares/assessment.crud';
import { useSelector } from 'react-redux';
import { getReportModel } from 'keys/ordering';
import { Title as ScreenTitle } from 'components'
import { ReactComponent as ListIcon } from 'assets/icons/List.svg';
import { ReactComponent as ChartIcon } from 'assets/icons/Chart.svg';
import { IconButtonGroup } from 'components/Form';
import { WrapViewTypes } from './Style'
import { IconButtonGroups } from 'styles/GlobalStyle';
import { statusOptions } from './hooks/useHeaderItems';

const WarpAssessmentsContext = (props) => {
    const location = useLocation();
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)
    const queryClient = useQueryClient()

    const viewTypes = { table: "table", chart: "chart" }

    const [assessmentFilters, setAssessmentFilters] = useState({
        year: null,
        semester: null,
        assessment_def: null,
        gender: null,
        category: null,
        grade_of_allocation: null,
        status: [statusOptions[0]]
    })
    const [pageSize, setPageSize] = useState(15)
    const [viewCell, setViewCell] = useState({
        ["calculations.fluency"]: "icon",
        ["calculations.percent_accuracy"]: "icon",
        ["calculations.fluency_reading"]: "icon",
        ["calculations.factored_percent_accuracy"]: "icon",
        ["calculations.words_correct_per_minute"]: "icon",
        prosody: "icon"
    })
    const [page, setPage] = useState(initialPage)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [viewScreen, setViewScreen] = useState(location?.state?.view || viewTypes.table)

    const model = getReportModel(viewCell)

    const assessmentOptions = queryOptions({
        queryKey: [qc.report, page, pageSize, sorting, headerFilters, testTaker],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentReportFetch({ assessmentFilters, headerFilters, testTaker, signal, page, pageSize, sorting, search: searchVal, customModel: model })
            return data
        },
        enabled: viewScreen === viewTypes.table
    })

    const assessments = useQuery(assessmentOptions)

    const refetchTableData = useCallback(async () => {
        setPage(initialPage)
        assessments.remove?.()
        assessments.refetch()
    }, [])

    const refetchChartData = useCallback(async () => {
        queryClient.invalidateQueries([qc.fluencyDoughnut, qc.percentAccuracyDoughnutChart, qc.factoredPercentAccuracyDoughnut, qc.fluencyReadingDoughnut, qc.correctWordsPerMinuteDoughnut])
    }, [])

    const commonState = {
        viewCell, setViewCell,
        assessments,
        viewTypes,
        page, setPage,
        sorting, setSorting,
        searchVal, setSearchVal,
        assessmentOptions,
        viewScreen,
        assessmentFilters, setAssessmentFilters,
        refetchTableData,
        refetchChartData,
        pageSize, setPageSize
    }

    const viewTypeBtns = [
        {
            icon: ListIcon,
            type: viewTypes.table
        },
        {
            icon: ChartIcon,
            type: viewTypes.chart
        }
    ]

    const changeViewType = useCallback(({ type }) => {
        setViewScreen(type)
    }, [])

    return (
        <AssessmentsContext.Provider value={commonState}>
            <ScreenTitle {...props} breadcrumbs={true}>
                <WrapViewTypes>
                    <IconButtonGroups>
                        {viewTypeBtns.map((act, index) =>
                            <IconButtonGroup
                                selected={act.type == viewScreen}
                                icon={act.icon}
                                action={() => changeViewType(act)}
                                iconSize={{
                                    width: 20,
                                    height: 20
                                }}
                            />
                        )}
                    </IconButtonGroups>
                </WrapViewTypes>
            </ScreenTitle>
            <Assessments {...props} />
        </AssessmentsContext.Provider>
    )
}

export const AssessmentsContext = React.createContext()
export default WarpAssessmentsContext